import triggerPopup from "../components/_trigger-popup";
import responsiveVideo from "../components/_responsive-video";

// All main index related JavaScript goes here...
responsiveVideo();

const carousel = document.querySelector("#renderings-carousel");

setTimeout(() => {
    carousel.classList.add("add-shadow");
}, 5000);

/* ******************** TRIGGER POPUP ON PAGE LOAD ******************** */
// triggerPopup("#popup");
